export const ASYNC_URL = [
    '/apiDocusign/docusign/send-contract'
];
